import { createContext, useState, useContext, ReactNode } from 'react';
import Spinner from 'react-bootstrap/Spinner';

interface OverlayContextProps {
    showOverlay: (text?: string, dontCloseOnTouch?: boolean) => void;
    hideOverlay: () => void;
    overlayText: string;
    dontCloseOnTouch: boolean;
}

const defaultContextProps = {
    showOverlay: () => {},
    hideOverlay: () => {},
    overlayText: '',
    dontCloseOnTouch: false,
};

const OverlayContext = createContext<OverlayContextProps>(defaultContextProps);

export const OverlayProvider = ({ children }: { children: ReactNode }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [overlayText, setOverlayText] = useState('');
    const [dontCloseOnTouch, setDontCloseOnTouch] = useState(false);

    const showOverlay = (text = '', dontClose = false) => {
        setOverlayText(text);
        setDontCloseOnTouch(dontClose);
        setIsVisible(true);
    };
    const hideOverlay = () => setIsVisible(false);

    return (
        <OverlayContext.Provider value={{ showOverlay, hideOverlay, overlayText, dontCloseOnTouch }}>
            {children}
            {isVisible && (
                <button className="overlay-big-button" onClick={!dontCloseOnTouch ? hideOverlay : undefined}>
                    <Spinner animation="border" variant="light" />
                    {overlayText ? <span className="overlay-text">{overlayText}</span> : null}
                </button>
            )}
        </OverlayContext.Provider>
    );
};

export const useOverlay = (): OverlayContextProps => {
    const context = useContext(OverlayContext);
    if (!context) {
        throw new Error('useOverlay must be used within an OverlayProvider');
    }
    return context;
};
